import React from 'react'

export class Window extends React.Component{
    render(){
        return(
<img src="https://cdn.jsdelivr.net/gh/moezx/cdn@3.4.5/img/Sakura/images/ua/svg/windows_win10.svg"/>        )
    }
}


export class Mac extends React.Component{
    render(){
        return(
        <img src="https://cdn.jsdelivr.net/gh/moezx/cdn@3.4.5/img/Sakura/images/ua/svg/macos.svg"/> 
    
    
    )   }
}


export class Linux extends React.Component{
    render(){
        return(
            <img src="https://cdn.jsdelivr.net/gh/moezx/cdn@3.4.5/img/Sakura/images/ua/svg/linux.svg"/>
        )
    }
}


export class Android extends React.Component{
    render(){
        return(
<img src="https://cdn.jsdelivr.net/gh/moezx/cdn@3.4.5/img/Sakura/images/ua/svg/android.svg"/>

)
    }
}






export class Chrome extends React.Component{
    render(){
        return(
<img src="https://cdn.jsdelivr.net/gh/moezx/cdn@3.4.5/img/Sakura/images/ua/svg/chrome.svg"/>        
    
    
    
    )
}
}



export class Firefox extends React.Component{
    render(){
        return(
<img src="https://cdn.jsdelivr.net/gh/moezx/cdn@3.4.5/img/Sakura/images/ua/svg/firefox.svg"/>
       



)

}}

export class Edge extends React.Component{
    render(){
        return(
<img src="https://cdn.jsdelivr.net/gh/moezx/cdn@3.4.5/img/Sakura/images/ua/svg/edge.svg"/>
       



)

}}
export class Safari extends React.Component{
    render(){
        return(
<img src="https://cdn.jsdelivr.net/gh/moezx/cdn@3.4.5/img/Sakura/images/ua/svg/safari.svg"/>
       



)

}}


export class QQBrowser extends React.Component{
    render(){
        return(
<img src="https://cdn.jsdelivr.net/gh/moezx/cdn@3.4.5/img/Sakura/images/ua/svg/QQBrowser.svg"/>       



)

}}


export class Unknow extends React.Component{
    render(){
        return(
<img src="https://cdn.jsdelivr.net/gh/moezx/cdn@3.4.5/img/Sakura/images/ua/svg/unknow.svg"/>


)

}}

export class Bro360 extends React.Component{
    render(){
        return(
<img src="https://cdn.jsdelivr.net/gh/moezx/cdn@3.4.5/img/Sakura/images/ua/svg/360.svg"/>


)

}}


export class Ie extends React.Component{
    render(){
        return(
<img src="https://cdn.jsdelivr.net/gh/moezx/cdn@3.4.5/img/Sakura/images/ua/svg/ie.svg"/>


)

}}



export class Opera extends React.Component{
    render(){
        return(
<img src="https://cdn.jsdelivr.net/gh/moezx/cdn@3.4.5/img/Sakura/images/ua/svg/opera.svg"/>


)

}}


export class Maxthon extends React.Component{
    render(){
        return(
<img src="https://cdn.jsdelivr.net/gh/moezx/cdn@3.4.5/img/Sakura/images/ua/svg/maxthon.svg"/>


)

}}


export class Sogou extends React.Component{
    render(){
        return(
<img src="https://cdn.jsdelivr.net/gh/moezx/cdn@3.4.5/img/Sakura/images/ua/svg/sogou.svg"/>


)

}}




export class Ucweb extends React.Component{
    render(){
        return(
<img src="https://cdn.jsdelivr.net/gh/moezx/cdn@3.4.5/img/Sakura/images/ua/svg/ucweb.svg"/>


)

}}

